interface iAoVivoContainerProps {
  children?: React.ReactNode;
  className?: string;
}

function EventContainer({ children, className }: iAoVivoContainerProps) {
  return (
    <div
      className={`hidden min-h-[445px] flex-col gap-xl rounded-md bg-color-lightest p-4 shadow-level-2 ${
        className ?? ''
      }`}
    >
      {children}
    </div>
  );
}

export { EventContainer };
